/* Just Brilliant: keyboard-accessible bag removal with an inline confirmation. */
if (!customElements.get('cart-remove')) customElements.define('cart-remove', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.setAttribute('role', 'button');
    this.tabIndex = 0;
    const row = this.closest('.product-cart-item, tr');
    const title = row?.querySelector('.cart-product-link')?.textContent.trim() || 'product';
    this.setAttribute('aria-label', 'Remove ' + title);
    this.addEventListener('click', event => { event.preventDefault(); this.confirm(); }, { signal });
    this.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.confirm(); }
    }, { signal });
  }
  confirm() {
    const drawer = this.closest('cart-drawer');
    if (!drawer) { this.removeItem(); return; }
    if (drawer._jbCartPending || this.confirmation) return;
    const row = this.closest('.product-cart-item');
    if (!row) return;
    // Close another line's confirmation before presenting this one.
    drawer.querySelectorAll('cart-remove').forEach(control => { if (control !== this) control.cancel?.(false); });
    const panel = document.createElement('div');
    panel.className = 'jb-cart-remove-confirmation';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Remove product confirmation');
    panel.innerHTML = '<strong>Remove product?</strong><p>Are you sure you want to remove this creation from your bag?</p><div><button type="button" data-cancel>Cancel</button><button type="button" data-confirm>Yes</button></div>';
    this.confirmation = panel;
    row.classList.add('is-confirming-removal');
    row.append(panel);
    panel.querySelector('[data-cancel]').addEventListener('click', () => this.cancel());
    panel.querySelector('[data-confirm]').addEventListener('click', () => { this.cancel(false); this.removeItem(); });
    panel.addEventListener('keydown', event => { if (event.key === 'Escape') { event.stopPropagation(); this.cancel(); } });
    panel.querySelector('[data-cancel]').focus({ preventScroll: true });
  }
  cancel(focus = true) {
    this.confirmation?.remove(); this.confirmation = null;
    this.closest('.product-cart-item')?.classList.remove('is-confirming-removal');
    if (focus && this.isConnected) this.focus({ preventScroll: true });
  }
  removeItem() {
    const cart = this.closest('cart-drawer, theme-cart');
    return cart?.updateQuantity(this.dataset.index, '0');
  }
  disconnectedCallback() { this.cancel(false); this.controller?.abort(); this.controller = null; }
});
